document.addEventListener('DOMContentLoaded', () => {
	$('[data-tab]').click((e) => {
		$('[data-tab]').removeClass('active');
		$(e.target).addClass('active');

		// console.log($(e.target).attr('data-tab'));
		$('[data-tab-bontent]').removeClass('active');
		$(`[data-tab-bontent="${ $(e.target).attr('data-tab') }"]`).addClass('active');
	})
});